import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { SettingsService } from '../../settings.service';
import { EventsService } from '../../core/event.service';
import { LocalisationService } from '../../core/localisation.service';
import { GridService } from '../../grids/grid.service';
import { PluginViewBase } from '../../grids/plugins/plugin-view/plugin-view.base';
import { ActionService } from '../../core/action.service';
import { AlertsService } from '../../core/alerts.service';
var PluginViewShrinkageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PluginViewShrinkageComponent, _super);
    /**
     * Creates an instance of PluginViewShrinkageComponent.
     * @param {LocalisationService} localisationService
     * @param {ChangeDetectorRef} changeDetector
     * @param {EventsService} eventsService
     * @param {GridService} gridService
     * @param {SettingsService} settingsService
     * @memberOf PluginViewShrinkageComponent
     */
    function PluginViewShrinkageComponent(localisationService, changeDetector, eventsService, gridService, settingsService, actionService, alertsService) {
        var _this = _super.call(this, localisationService, changeDetector, eventsService, gridService, settingsService) || this;
        _this.actionService = actionService;
        _this.alertsService = alertsService;
        /**
         * The days of the week from 0 to 6.
         * @memberOf PluginViewShrinkageComponent
         */
        _this.days = [];
        /**
         * The labels for the days of the week.
         * @memberOf PluginViewShrinkageComponent
         */
        _this.labels = {
            long: [
                'APP.PLUGINS.MONDAY',
                'APP.PLUGINS.TUESDAY',
                'APP.PLUGINS.WEDNESDAY',
                'APP.PLUGINS.THURSDAY',
                'APP.PLUGINS.FRIDAY',
                'APP.PLUGINS.SATURDAY',
                'APP.PLUGINS.SUNDAY'
            ],
            short: [
                'APP.PLUGINS.MONDAY_SHORT',
                'APP.PLUGINS.TUESDAY_SHORT',
                'APP.PLUGINS.WEDNESDAY_SHORT',
                'APP.PLUGINS.THURSDAY_SHORT',
                'APP.PLUGINS.FRIDAY_SHORT',
                'APP.PLUGINS.SATURDAY_SHORT',
                'APP.PLUGINS.SUNDAY_SHORT'
            ]
        };
        for (var day = 0; day < 7; day++) {
            _this.days.push(day);
        }
        return _this;
    }
    /**
     * Opens the shrinkage overlay.
     * @param {any} day The day of the week, where Monday = 0.
     * @memberOf PluginViewShrinkageComponent
     */
    PluginViewShrinkageComponent.prototype.openOverlay = function (day) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var input, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        input = {
                            actionConfiguration: {
                                name: 'open-overlay-shrinkage',
                                configuration: null,
                                method: day
                            },
                            item: this.selectedFunction
                        };
                        return [4 /*yield*/, this.actionService.doAction(input)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        if (error_1) {
                            if (!error_1.labelKey) {
                                return [2 /*return*/, this.alertsService.createAlert('danger', 'APP.SOCIAL.ACTION_NOT_FOUND', new Error('No labelKey is found'))];
                            }
                            if (!error_1.message) {
                                return [2 /*return*/, this.alertsService.createAlert('danger', error_1.labelKey)];
                            }
                            return [2 /*return*/, this.alertsService.createAlert('danger', error_1.labelKey, error_1.message)];
                        }
                        return [2 /*return*/, this.alertsService.createAlert('danger', 'APP.SOCIAL.ACTION_NOT_FOUND', new Error('Received Error is undefined'))];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return PluginViewShrinkageComponent;
}(PluginViewBase));
export { PluginViewShrinkageComponent };
